import React, { useEffect, useContext, useState } from "react";
// import Header from "../components/dashboard/header";
import Footer from "./Footer";
import Header from "./Header";
import { useNavigate, Link } from "react-router-dom";
import leactureModule from '../assets/images/lecture-modules.svg';
import videoModule from '../assets/images/Video-Library.svg';
import sessionbg from "../assets/images/session-bg.svg";
import cpcSess from "../assets/images/icons/cpc-sess.svg";
import fellowShip from "../assets/images/icons/fellowship-pro.svg";
import videoLec from "../assets/images/icons/video-lec.svg";
import quizzAsse from "../assets/images/icons/quizzes-ass.svg";
import slideSem from "../assets/images/icons/slide-sem.svg";
import businessdeal from "../assets/images/business-handshake--deal-contract-business-money-payment-agreement.svg";
import ourVision from '../assets/images/ourVision.svg';
import { contentContext } from "../context/contentContext";
import SweetAlert from 'react-bootstrap-sweetalert';

const LearningHub = () => {
    const [alertMsg, setAlertMsg] = useState(false)
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, setMenuLearning, menuLearningActive, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handelnavigation4 = () => {
        // localStorage.setItem('', "")
        const token = localStorage.getItem("token");
        if (token && userData?.userType === 'ADMIN') {

            setAlertMsg(true)
        } else {
            navigate("/lecture-library")
        }
    }
    const handelnavigation5 = () => {
        // localStorage.setItem('', "")
        const token = localStorage.getItem("token");
        console.log('token', token, userData?.userType)
        if (token && userData?.userType === 'ADMIN') {

            setAlertMsg(true)
        } else {
            navigate("/moduleslibrary")
        }


    }
    const handelnavigation3 = () => {
        localStorage.setItem('userType', "CLINICIAN")

        navigate("/signup")

    }

    return (
        <>
            <Header />

            <section className="about-us-section ">
                <div className="container">
                    <h3 className="txt-48 ">Learning Hub</h3>
                    <p className="txt-16 ">Precision Diagnostics. Lifelong Learning. Global Impact.</p>
                </div>
            </section>

            <section className="learning-hub-section">
                <div className="we-are_bg">
                    <img src={sessionbg} alt="DADI Logo" width="1130" />
                </div>
                <div className="container py-5">
                    <div className="text-center mb-3">
                        <h3 className="txt-48 ">Empowering Dermatopathology Education Through <br className="d-none d-md-block" /> Innovation and Access</h3>
                        <p className="txt-13">The DADI Learning Hub is a comprehensive digital platform designed to advance knowledge and clinical skills in <br className="d-none d-md-block" /> dermatopathology. Whether you're a practicing clinician, pathology resident, or a postgraduate student, our Learning  <br className="d-none d-md-block" /> Hub offers expertly curated resources that bridge the gap between theory and real-world application.</p>
                    </div>

                    <div className="row key-feu-expo">
                        {/* KEY FEATURES */}
                        <div className="col-lg-7">
                            <h4 className="key-feu-txt">Key Features</h4>
                            <div className="row">

                                <div className="col-sm-6 feature-item">
                                    <img src={cpcSess} alt="Icon" width="40" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>CPC (Clinicopathological Correlation) Sessions</h6>
                                        <p>Engage with challenging case-based discussions guided by leading experts.</p>
                                    </div>
                                </div>

                                <div className="col-sm-6 feature-item">
                                    <img src={fellowShip} alt="Icon" width="40" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Fellowship Programs</h6>
                                        <p>Structured learning tracks tailored to foundational and advanced levels in dermatopathology.</p>
                                    </div>
                                </div>

                                <div className="col-sm-6 feature-item">
                                    <img src={videoLec} alt="Icon" width="40" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Video Lectures & Webinars</h6>
                                        <p>Access high-quality, on-demand content from nationally and internationally renowned faculty.</p>
                                    </div>
                                </div>

                                <div className="col-sm-6 feature-item">
                                    <img src={quizzAsse} alt="Icon" width="40" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Quizzes & Assessments</h6>
                                        <p>Self-paced learning with periodic evaluations to reinforce and test your understanding.</p>
                                    </div>
                                </div>

                                <div className="col-sm-12 feature-item">
                                    <img src={slideSem} alt="Icon" width="40" className="feature-icon"></img>
                                    <div className="feature-text">
                                        <h6>Slide Seminars</h6>
                                        <p>Enhance diagnostic precision through digital slide reviews and case interpretations.</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* Explore Buttons */}
                        <div className="col-lg-5 explore-box mt-5 mt-lg-0">
                            <div className="bg-light-tint p-4">
                                <h4 className="mb-4">Explore</h4>

                                <button className="explore-card card-orange" onClick={(e) => handelnavigation4()}>
                                    <h6 className="video-txt text-start"><span className="material-symbols-outlined  btn-icon-fill-style">keyboard_arrow_right</span>VIDEO LIBRARY</h6>
                                    <p className="text-start">
                                        Video Learning for the Inquisitive
                                        <span className="d-none d-md-inline"><br /></span>
                                        Clinician
                                    </p>
                                    <p className="badge text-start">29 total hours · 114 Lectures</p>
                                    <div className="video-module">
                                        <img src={videoModule} alt="video-module-img" />
                                    </div>

                                </button>

                                <button className="explore-card card-green" onClick={(e) => handelnavigation5()}>
                                    <h6 className="lecture-txt text-start"><span className="material-symbols-outlined  btn-icon-fill-style">keyboard_arrow_right</span>LECTURE MODULES</h6>
                                    <p className="text-start">
                                        Explore Expert Insights: CPCs,
                                        <span className="d-none d-md-inline"><br /></span>
                                        Fellowships, Lectures & More
                                    </p>
                                    <p className="lec-badge text-start">29 total hours · 114 Lectures</p>
                                    <div className="lecture-img">
                                        <img src={leactureModule} alt="lecture-module-img" />
                                    </div>
                                </button>
                            </div>

                        </div>
                        <div className="diagnostics-section learning-hub-vision">
                            <section className="who-we-are-section">
                                <div className="vision-section">
                                    <div className="image-container">
                                        <img src={ourVision} alt="Doctors Vision" />
                                    </div>
                                    <div className="vision-text">
                                        {/* <h3 className="txt-48">Our Vision</h3> */}
                                        Our goal is to bridge clinical practice and pathology expertise,<br className="d-none d-md-block" /> helping healthcare professionals improve diagnostic accuracy and patient outcomes.
                                    </div>
                                </div>
                            </section>
                        </div>
                        <SweetAlert
                            show={alertMsg}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Access restricted. This page is not available to Admin users."}
                            onConfirm={e => setAlertMsg(false)}
                            id="error-alert"
                        ></SweetAlert>
                    </div>


                    {/* <div className="mt-2 text-center">
                        <p className="txt-22 end-txt">Our goal is to foster a lifelong learning culture, empowering <br className="d-none d-md-block" /> professionals to deliver better care through enhanced diagnostic capabilities.</p>
                    </div> */}
                </div>
            </section>

            {/* <div className="service-link">
    
                    <button className="btn-fill-icon" onClick={(e) => handelnavigation4()}><span className="material-symbols-outlined  btn-icon-fill-style">keyboard_arrow_right</span>VIDEO LIBRARY</button>
                    &nbsp;&nbsp;
                    <button className="btn-fill-icon" onClick={(e) => handelnavigation3()}><span className="material-symbols-outlined  btn-icon-fill-style">keyboard_arrow_right</span>LECTURE MODULES</button>
    
    
                </div> */}





            <Footer />
        </>
    );
};

export default LearningHub;
